import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ModalContentBase from '../modal/modal_content_base';
import {
  groupPrefsByRegion,
  shortPrefName,
} from '../modal/modal_item/pref_2026_regions';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    countriesPrefs: PropTypes.array.isRequired,
    circle: PropTypes.object.isRequired,
    handlePrefChange: PropTypes.func.isRequired
  },
  closeModalPrefSelector() {
    this.modalPrefSelector.closeModal();
  },
  onChange() {
    this.props.handlePrefChange();
    setTimeout(() => {
      this.modalPrefSelector.closeModal();
    }, 100);
  },
  render() {
    const countriesPrefsArray = this.props.countriesPrefs;
    const optionId = this.props.circle[this.props.name];
    const selectedPref = countriesPrefsArray.find(pref => pref.id == optionId);
    const countriesPrefPreviewContent = (
      <p className="nav-link link--arrow p-0 mb-0">
        {selectedPref ? selectedPref.name : '選択してください'}
      </p>
    );

    // 見た目はヘッダーの「地域を選択」と同じ（地方ごとの四角いボタン）。
    // 選んだ県の読み取り（name の radio）と、選んだら閉じる動きはこれまでと同じ
    const prefChip = pref => (
      <React.Fragment key={pref.id}>
        <input
          type="radio"
          name={this.props.name}
          id={`pref_${pref.id}`}
          className="d-none"
          value={pref.id}
          onChange={this.onChange}
          defaultChecked={
            this.props.name === 'pref_id'
              ? pref.id == this.props.circle.pref_id
              : pref.id == this.props.circle.meeting_pref_id
          }
        />
        <label
          className={`pref-2026__chip${
            pref.id == optionId ? ' is-selected' : ''
          }`}
          htmlFor={`pref_${pref.id}`}
        >
          <span className="pref-2026__name">{shortPrefName(pref.name)}</span>
        </label>
      </React.Fragment>
    );

    const countriesPrefsBox = (
      <div className="pref-2026">
        <div className="pref-2026__head">
          <p className="pref-2026__title">地域を選択</p>
          <button
            type="button"
            className="close close__modal pref-2026__close"
            aria-label="閉じる"
            onClick={this.closeModalPrefSelector}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="pref-2026__body">
          {groupPrefsByRegion(countriesPrefsArray).map(({ label, prefs }) => (
            <div className="pref-2026__group" key={label}>
              <p className="pref-2026__grouptitle">{label}</p>
              <div className="pref-2026__grid">{prefs.map(prefChip)}</div>
            </div>
          ))}
        </div>
      </div>
    );

    return (
      <div className="pref-2026-modal">
        <ModalContentBase
          ref={c => {
            this.modalPrefSelector = c;
          }}
          previewContent={countriesPrefPreviewContent}
          modalContent={countriesPrefsBox}
          hideXBtn
        />
      </div>
    );
  }
});
